import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { tokens } from 'styling/tokens'
import {
  AttendanceBody,
  Donut,
  DonutHole,
  DonutCount,
  DonutSub,
  Legend,
  LegendRow,
  LegendDot,
  LegendLabel,
  LegendValue,
  LegendPct,
} from '../hrLayout.styled'

export const AttendanceDonut = () => {
  const { attendanceSummary } = useSelector((state: RootState) => state.hrDashboard)

  const attendance = useMemo(() => {
    const a = attendanceSummary
    const rows = [
      { label: 'Present', value: a?.present ?? 231, color: tokens.status.success.fg },
      { label: 'Leave', value: a ? a.leave + a.vacation : 17, color: tokens.status.warning.fg },
      { label: 'Absent', value: a?.absent ?? 14, color: tokens.status.danger.fg },
      { label: 'Sick', value: a?.sickLeave ?? 6, color: tokens.status.info.fg },
      { label: 'Off day', value: a?.offDay ?? 12, color: tokens.text.muted },
    ]
    const total = rows.reduce((sum, r) => sum + r.value, 0)
    let acc = 0
    const stops = rows
      .filter((r) => r.value > 0)
      .map((r) => {
        const start = total ? (acc / total) * 100 : 0
        acc += r.value
        const end = total ? (acc / total) * 100 : 0
        return `${r.color} ${start}% ${end}%`
      })
    const gradient = stops.length
      ? `conic-gradient(${stops.join(', ')})`
      : `conic-gradient(${tokens.border.hairline} 0 100%)`
    const legend = rows.map((r) => ({ ...r, pct: total ? Math.round((r.value / total) * 100) : 0 }))
    return { gradient, present: a?.present ?? 231, legend, total }
  }, [attendanceSummary])

  return (
    <AttendanceBody>
      <Donut $gradient={attendance.gradient}>
        <DonutHole>
          <DonutCount>{attendance.present}</DonutCount>
          <DonutSub>PRESENT</DonutSub>
        </DonutHole>
      </Donut>
      <Legend>
        {attendance.legend.map((r) => (
          <LegendRow key={r.label}>
            <LegendDot $color={r.color} />
            <LegendLabel>{r.label}</LegendLabel>
            <LegendValue>{r.value}</LegendValue>
            <LegendPct>{r.pct}%</LegendPct>
          </LegendRow>
        ))}
      </Legend>
    </AttendanceBody>
  )
}
